import type { FaireProductEntity } from "../../entity_types/product";

export const p_mea7tnxym6: FaireProductEntity = {
  token: "p_mea7tnxym6",
  type: "product",
  name: '(DZ)WORRY STONES - CHALCEDONY, BLUE (DZ) 1.5-1.75"',
  brandToken: "b_b1k03395mh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e60a769528922f68baa8c51710b3cd0d9352708a97e7c9335e8a527f7d997a9a.jpeg",
  galleryImageUrls: [],
  priceDollars: 48.09,
  description: '(DZ)WORRY STONES - CHALCEDONY, BLUE (DZ) 1.5-1.75"',
  tags: [],
  msrpDollars: 96.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:03.669Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
